import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveDirective as _resolveDirective, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "column" }
const _hoisted_2 = { class: "column" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { style: {"white-space":"normal","word-break":"break-word","line-height":"1.3"} }
const _hoisted_5 = { class: "row no-wrap" }
const _hoisted_6 = { class: "row no-wrap" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "column" }
const _hoisted_9 = {
  key: 0,
  class: "q-mt-sm q-pa-sm",
  style: {"background":"#f5f5f5","border-radius":"4px","font-size":"12px","line-height":"1.4"}
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "q-mt-xs" }
const _hoisted_13 = { class: "text-grey-7" }
const _hoisted_14 = { class: "column" }
const _hoisted_15 = { class: "col q-pb-sm" }
const _hoisted_16 = {
  class: "column",
  style: {"max-height":"300px","overflow-y":"auto"}
}
const _hoisted_17 = { class: "col q-pb-sm" }
const _hoisted_18 = { class: "row justify-center items-start q-gutter-md" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "text-h6" }
const _hoisted_22 = { class: "row justify-center items-start q-gutter-md" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_PigRunSummary = _resolveComponent("PigRunSummary")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_time = _resolveComponent("q-time")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_option_group = _resolveComponent("q-option-group")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _component_MLBadge = _resolveComponent("MLBadge")!
  const _component_q_table = _resolveComponent("q-table")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_card, {
      square: "",
      flat: "",
      bordered: "",
      class: "my-card bg-grey-1 vertical-bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar_title, { class: "text-weight-bold text-grey-brand" }, {
              default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                _createTextVNode("Report Manager", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_q_btn, {
              flat: "",
              round: "",
              dense: "",
              icon: "close",
              onClick: _ctx.onReportManagerCloseClick
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_q_card_section, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_q_select, {
                modelValue: _ctx.selectedReportType,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedReportType) = $event)),
                  _ctx.onReportTypeSelect
                ],
                dense: "",
                color: "blue-brand",
                outlined: "",
                options: _ctx.reportTypeOptions,
                label: "Select Report Type"
              }, null, 8, ["modelValue", "options", "onUpdate:modelValue"])
            ])
          ]),
          _: 1
        }),
        _withDirectives(_createVNode(_component_q_card_section, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.completedPigRuns.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_q_select, {
                      modelValue: _ctx.selectedCompletedPigRun,
                      "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedCompletedPigRun) = $event)),
                        _ctx.onCompletedPigRunSelect
                      ],
                      dense: "",
                      color: "blue-brand",
                      outlined: "",
                      options: _ctx.completedPigRunOptions,
                      label: "Select Completed Pig Run",
                      "popup-content-style": "white-space: normal; word-break: break-word;"
                    }, {
                      "selected-item": _withCtx((scope) => [
                        _createElementVNode("span", _hoisted_4, _toDisplayString(scope.opt.label), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "options", "onUpdate:modelValue"]),
                    _createVNode(_component_PigRunSummary, {
                      ref: "pigRunSummary",
                      "pig-run-id": _ctx.selectedCompletedPigRunId
                    }, null, 8, ["pig-run-id"]),
                    _createVNode(_component_q_input, {
                      modelValue: _ctx.completedPigRunReportStartDate,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.completedPigRunReportStartDate) = $event)),
                      dense: "",
                      filled: "",
                      clearable: "",
                      mask: "####-##-## ##:##:##",
                      label: "From (UTC)",
                      hint: "Optional, YYYY-MM-DD HH:mm:ss",
                      "data-testid": "completed-report-from"
                    }, {
                      append: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: "event",
                          class: "cursor-pointer"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_popup_proxy, {
                              "transition-show": "scale",
                              "transition-hide": "scale"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_5, [
                                  _createVNode(_component_q_date, {
                                    modelValue: _ctx.completedPigRunReportStartDate,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.completedPigRunReportStartDate) = $event)),
                                    mask: "YYYY-MM-DD HH:mm:ss"
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_q_time, {
                                    modelValue: _ctx.completedPigRunReportStartDate,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.completedPigRunReportStartDate) = $event)),
                                    mask: "YYYY-MM-DD HH:mm:ss",
                                    format24h: "",
                                    "with-seconds": ""
                                  }, null, 8, ["modelValue"])
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_q_input, {
                      modelValue: _ctx.completedPigRunReportEndDate,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.completedPigRunReportEndDate) = $event)),
                      dense: "",
                      filled: "",
                      clearable: "",
                      mask: "####-##-## ##:##:##",
                      label: "To (UTC)",
                      hint: "Optional, YYYY-MM-DD HH:mm:ss",
                      "data-testid": "completed-report-to"
                    }, {
                      append: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: "event",
                          class: "cursor-pointer"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_popup_proxy, {
                              "transition-show": "scale",
                              "transition-hide": "scale"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_6, [
                                  _createVNode(_component_q_date, {
                                    modelValue: _ctx.completedPigRunReportEndDate,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.completedPigRunReportEndDate) = $event)),
                                    mask: "YYYY-MM-DD HH:mm:ss"
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_q_time, {
                                    modelValue: _ctx.completedPigRunReportEndDate,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.completedPigRunReportEndDate) = $event)),
                                    mask: "YYYY-MM-DD HH:mm:ss",
                                    format24h: "",
                                    "with-seconds": ""
                                  }, null, 8, ["modelValue"])
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_q_select, {
                      modelValue: _ctx.completedPigRunReportMarkerId,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.completedPigRunReportMarkerId) = $event)),
                      dense: "",
                      filled: "",
                      clearable: "",
                      "emit-value": "",
                      "map-options": "",
                      options: _ctx.completedPigRunReportMarkerOptions,
                      loading: _ctx.completedPigRunReportMarkersLoading,
                      disable: _ctx.selectedCompletedPigRunId === undefined,
                      label: "Marker (optional)",
                      "data-testid": "completed-report-marker"
                    }, null, 8, ["modelValue", "options", "loading", "disable"]),
                    _createVNode(_component_q_checkbox, {
                      modelValue: _ctx.selectedPigRunIncludeVerifiedPassagesOnly,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedPigRunIncludeVerifiedPassagesOnly) = $event)),
                      color: "blue-brand"
                    }, {
                      default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                        _createTextVNode("Include Verified Passages Only", -1)
                      ]))]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_q_btn, {
                      class: "btn-brand",
                      label: "Generate Report Data",
                      dense: "",
                      "no-caps": "",
                      loading: _ctx.completedPigRunReportGenerateReportLoading,
                      onClick: _ctx.onCompletedPigRunGenerateReportClick
                    }, null, 8, ["loading", "onClick"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, "There are no completed pig runs to report on."))
            ])
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.showReportTypeCompletedPigRun]
        ]),
        _withDirectives(_createVNode(_component_q_card_section, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_q_btn, {
                class: "btn-brand",
                label: "Enter report parameters",
                dense: "",
                "no-caps": "",
                onClick: _ctx.onEnterReportParametersForDevicesReportClick
              }, null, 8, ["onClick"]),
              (_ctx.hasDevicesReportParameters)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _cache[36] || (_cache[36] = _createElementVNode("div", { class: "text-bold q-mb-xs" }, "Parameters", -1)),
                    _createElementVNode("div", null, [
                      _cache[32] || (_cache[32] = _createElementVNode("span", { class: "text-grey-7" }, "Start:", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.startDateDevicesReport), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[33] || (_cache[33] = _createElementVNode("span", { class: "text-grey-7" }, "End:", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.endDateDevicesReport), 1)
                    ]),
                    (_ctx.devicesReportPigRunId != null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _cache[34] || (_cache[34] = _createElementVNode("span", { class: "text-grey-7" }, "Pig Run:", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.optionLabel(_ctx.devicesReportPigRunOptions, _ctx.devicesReportPigRunId)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.devicesReportMarkerId != null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _cache[35] || (_cache[35] = _createElementVNode("span", { class: "text-grey-7" }, "Marker:", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.optionLabel(_ctx.devicesReportMarkerOptions, _ctx.devicesReportMarkerId)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("span", _hoisted_13, "AGMs (" + _toDisplayString(_ctx.selectedDevicesForDevicesReport.length) + "):", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.truncatedDeviceLabelsForDevicesReport) + " ", 1),
                      (_ctx.selectedDevicesForDevicesReport.length > 5)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: "#",
                            style: {"font-size":"11px"},
                            onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.showAllAgmsSummary = !_ctx.showAllAgmsSummary), ["prevent"]))
                          }, _toDisplayString(_ctx.showAllAgmsSummary ? 'Show less' : 'Show all'), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _cache[37] || (_cache[37] = _createElementVNode("br", null, null, -1)),
              _createVNode(_component_q_btn, {
                class: "btn-brand",
                label: "Generate Report Data",
                dense: "",
                "no-caps": "",
                loading: _ctx.devicesReportGenerateReportLoading,
                onClick: _ctx.onGenerateReportDataForDevicesReportClick
              }, null, 8, ["loading", "onClick"])
            ])
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.showReportTypeDevice]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.showEnterParametersForDevicesReportDialog,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.showEnterParametersForDevicesReportDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"600px","max-width":"90vm"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar_title, { class: "text-blue-brand text-bold" }, {
                  default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                    _createTextVNode("Report Parameters", -1)
                  ]))]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_q_input, {
                      modelValue: _ctx.startDateDevicesReport,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.startDateDevicesReport) = $event)),
                      dense: "",
                      filled: "",
                      label: "Start Date (UTC)"
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: "event",
                          class: "cursor-pointer"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_popup_proxy, {
                              ref: "qStartDateProxy",
                              "transition-show": "scale",
                              "transition-hide": "scale"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_date, {
                                  modelValue: _ctx.startDateDevicesReport,
                                  "onUpdate:modelValue": [
                                    _cache[11] || (_cache[11] = ($event: any) => ((_ctx.startDateDevicesReport) = $event)),
                                    _ctx.hideStartDateProxy
                                  ],
                                  mask: "YYYY-MM-DD HH:mm:ss"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }, 512)
                          ]),
                          _: 1
                        })
                      ]),
                      append: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: "access_time",
                          class: "cursor-pointer"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_popup_proxy, {
                              ref: "qStartTimeProxy",
                              "transition-show": "scale",
                              "transition-hide": "scale"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_time, {
                                  modelValue: _ctx.startDateDevicesReport,
                                  "onUpdate:modelValue": [
                                    _cache[12] || (_cache[12] = ($event: any) => ((_ctx.startDateDevicesReport) = $event)),
                                    _ctx.hideStartTimeProxy
                                  ],
                                  mask: "YYYY-MM-DD HH:mm:ss",
                                  format24h: ""
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }, 512)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_q_input, {
                      modelValue: _ctx.endDateDevicesReport,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.endDateDevicesReport) = $event)),
                      dense: "",
                      filled: "",
                      label: "End Date (UTC)"
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: "event",
                          class: "cursor-pointer"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_popup_proxy, {
                              ref: "qEndDateProxy",
                              "transition-show": "scale",
                              "transition-hide": "scale"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_date, {
                                  modelValue: _ctx.endDateDevicesReport,
                                  "onUpdate:modelValue": [
                                    _cache[14] || (_cache[14] = ($event: any) => ((_ctx.endDateDevicesReport) = $event)),
                                    _ctx.hideEndDateProxy
                                  ],
                                  mask: "YYYY-MM-DD HH:mm:ss"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }, 512)
                          ]),
                          _: 1
                        })
                      ]),
                      append: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: "access_time",
                          class: "cursor-pointer"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_popup_proxy, {
                              ref: "qEndTimeProxy",
                              "transition-show": "scale",
                              "transition-hide": "scale"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_time, {
                                  modelValue: _ctx.endDateDevicesReport,
                                  "onUpdate:modelValue": [
                                    _cache[15] || (_cache[15] = ($event: any) => ((_ctx.endDateDevicesReport) = $event)),
                                    _ctx.hideEndTimeProxy
                                  ],
                                  mask: "YYYY-MM-DD HH:mm:ss",
                                  format24h: ""
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }, 512)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_q_select, {
                      modelValue: _ctx.devicesReportPigRunId,
                      "onUpdate:modelValue": [
                        _cache[17] || (_cache[17] = ($event: any) => ((_ctx.devicesReportPigRunId) = $event)),
                        _ctx.onDevicesReportPigRunChanged
                      ],
                      dense: "",
                      filled: "",
                      clearable: "",
                      "emit-value": "",
                      "map-options": "",
                      options: _ctx.devicesReportPigRunOptions,
                      label: "Pig Run (optional)",
                      class: "q-mt-sm",
                      "data-testid": "devices-report-pig-run"
                    }, null, 8, ["modelValue", "options", "onUpdate:modelValue"]),
                    _createVNode(_component_q_select, {
                      modelValue: _ctx.devicesReportMarkerId,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.devicesReportMarkerId) = $event)),
                      dense: "",
                      filled: "",
                      clearable: "",
                      "emit-value": "",
                      "map-options": "",
                      options: _ctx.devicesReportMarkerOptions,
                      loading: _ctx.devicesReportMarkersLoading,
                      disable: _ctx.devicesReportPigRunId == null,
                      label: "Marker (optional, needs a pig run)",
                      class: "q-mt-sm",
                      "data-testid": "devices-report-marker"
                    }, null, 8, ["modelValue", "options", "loading", "disable"])
                  ])
                ]),
                _createVNode(_component_q_separator),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_q_option_group, {
                      modelValue: _ctx.selectedDevicesForDevicesReport,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.selectedDevicesForDevicesReport) = $event)),
                      dense: "",
                      options: _ctx.allDeviceOptionsForDevicesReport,
                      color: "indigo-9",
                      type: "checkbox"
                    }, null, 8, ["modelValue", "options"])
                  ])
                ]),
                _createVNode(_component_q_separator),
                _createVNode(_component_q_card_actions, { align: "right" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_btn, {
                      class: "btn-brand",
                      label: "Set Parameters",
                      type: "button",
                      "no-caps": "",
                      onClick: _ctx.onSetParametersForDevicesReportClick
                    }, null, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.showCompletedPigRunReportDialog,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.showCompletedPigRunReportDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"1150px","max-width":"90vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar_title, { class: "text-blue-brand text-bold" }, {
                  default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                    _createTextVNode("Completed Pig Run Report Data", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "cloud_download",
                  onClick: _ctx.onDownloadCompletedPigRunReportData
                }, null, 8, ["onClick"]),
                _createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "filter_list",
                  onClick: _ctx.onToggleExportOptionsForCompletedPigRunReport
                }, null, 8, ["onClick"]),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _withDirectives(_createElementVNode("div", _hoisted_18, [
              _createElementVNode("span", null, [
                _createVNode(_component_q_checkbox, {
                  modelValue: _ctx.selectedPigRunIncludeVerifiedPassagesOnly,
                  "onUpdate:modelValue": [
                    _cache[21] || (_cache[21] = ($event: any) => ((_ctx.selectedPigRunIncludeVerifiedPassagesOnly) = $event)),
                    
                _ctx.onIncludeVerifiedPassagesOnlyCompletedPigRunReportInput
              
                  ],
                  color: "blue-brand"
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                _cache[40] || (_cache[40] = _createTextVNode("Include verified passages only", -1))
              ])
            ], 512), [
              [_vShow, _ctx.exportOptionsVisibleCompletedPigRunReport]
            ]),
            _createVNode(_component_q_separator),
            _createVNode(_component_q_table, {
              pagination: _ctx.completedPigRunReportDataPagination,
              "onUpdate:pagination": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.completedPigRunReportDataPagination) = $event)),
              "table-header-class": "bg-blue-brand text-white",
              rows: _ctx.completedPigRunReportData,
              columns: _ctx.completedPigRunReportColumns,
              "row-key": "passageTimeStamp",
              dense: "",
              "binary-state-sort": "",
              onRequest: _ctx.onCompletedPigRunReportRequest
            }, {
              "body-cell-passageTimeStamp": _withCtx((props) => [
                _createVNode(_component_q_td, { props: props }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.row.passageTimeStamp), 1)
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              "body-cell-markerName": _withCtx((props) => [
                _createVNode(_component_q_td, { props: props }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.row.markerName), 1)
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              "body-cell-toolName": _withCtx((props) => [
                _createVNode(_component_q_td, { props: props }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.row.toolName), 1)
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              "body-cell-coordinates": _withCtx((props) => [
                _createVNode(_component_q_td, { props: props }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.formatCoordinate(props.row.latitude, false) +
                _ctx.formatCoordinate(props.row.longitude, true) +
                _ctx.formatAltitude(props.row.altitude, true)), 1)
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              "body-cell-uid": _withCtx((props) => [
                _createVNode(_component_q_td, { props: props }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.row.uid), 1)
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              "body-cell-detection-count": _withCtx((props) => [
                _createVNode(_component_q_td, { props: props }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.row.detectionCount), 1)
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              "body-cell-passage-detected-frequency": _withCtx((props) => [
                _createVNode(_component_q_td, { props: props }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.row.detectionFrequency), 1)
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              "body-cell-graph-data": _withCtx((props) => [
                _createVNode(_component_q_td, { props: props }, {
                  default: _withCtx(() => [
                    (_ctx.isOnlySingleTypeOfPassage(props))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.passageWaveforms, (waveform) => {
                            return (_openBlock(), _createBlock(_component_q_btn, {
                              key: waveform.passageWaveformId,
                              size: "sm",
                              class: "q-mr-xs btn-brand",
                              dense: "",
                              icon: "show_chart",
                              label: _ctx.getWaveformLabel(waveform.passageWaveformType),
                              onClick: ($event: any) => (
                    _ctx.showChart(
                      props,
                      _ctx.getWaveformLabel(waveform.passageWaveformType)
                    )
                  )
                            }, null, 8, ["label", "onClick"]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_20, [
                          _createVNode(_component_q_btn_dropdown, {
                            size: "sm",
                            class: "q-mr-xs btn-brand",
                            dense: "",
                            icon: "show_chart"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_list, { dense: "" }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.passageWaveforms, (waveform) => {
                                    return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                      key: waveform.passageWaveformId,
                                      clickable: "",
                                      onClick: ($event: any) => (
                        _ctx.showChart(
                          { row: props.row },
                          _ctx.getWaveformLabel(waveform.passageWaveformType)
                        )
                      )
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_item_section, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_item_label, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.getWaveformLabel(waveform.passageWaveformType)), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])), [
                                      [_directive_close_popup]
                                    ])
                                  }), 128))
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              "body-cell-verify-passage": _withCtx((props) => [
                _createVNode(_component_q_td, { props: props }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_btn, {
                      size: "sm",
                      class: "btn-brand",
                      dense: "",
                      color: props.row.isVerified ? 'green' : 'red',
                      icon: props.row.isVerified ? 'check_circle_outline' : 'block',
                      onClick: ($event: any) => (_ctx.onVerifyPassageForCompletedPigRun(props.row))
                    }, null, 8, ["color", "icon", "onClick"])
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              "body-cell-machine-learning-data": _withCtx((props) => [
                _createVNode(_component_q_td, { props: props }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['elf', 'geo', 'mag', 'acc', 'tmr'], (type) => {
                      return (_openBlock(), _createElementBlock(_Fragment, null, [
                        (
                    props.row[`${type}MachineLearningResultList`] !==
                      undefined &&
                    props.row[`${type}MachineLearningResultList`].length !== 0
                  )
                          ? (_openBlock(), _createBlock(_component_MLBadge, {
                              key: type,
                              type: type,
                              results: props.row[`${type}MachineLearningResultList`]
                            }, null, 8, ["type", "results"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 64))
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              _: 1
            }, 8, ["pagination", "rows", "columns", "onRequest"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.showValidationMessageDialog,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.showValidationMessageDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.validationDialogTitle), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.validationDialogMessage), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, { align: "right" }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  label: "OK",
                  color: "primary"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.showDevicesReportDialog,
      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.showDevicesReportDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"1150px","max-width":"90vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar_title, { class: "text-blue-brand text-bold" }, {
                  default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                    _createTextVNode("By Agm(s) Report Data", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "cloud_download",
                  onClick: _ctx.onDownloadDevicesReportData
                }, null, 8, ["onClick"]),
                _createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "filter_list",
                  onClick: _ctx.onToggleExportOptionsForDevicesReport
                }, null, 8, ["onClick"]),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _withDirectives(_createElementVNode("div", _hoisted_22, [
              _createElementVNode("span", null, [
                _createVNode(_component_q_checkbox, {
                  modelValue: _ctx.includeVerifiedPassagesOnlyDevicesReport,
                  "onUpdate:modelValue": [
                    _cache[25] || (_cache[25] = ($event: any) => ((_ctx.includeVerifiedPassagesOnlyDevicesReport) = $event)),
                    
                _ctx.onIncludeVerifiedPassagesOnlyDevicesReportInput
              
                  ],
                  color: "blue-brand"
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                _cache[42] || (_cache[42] = _createTextVNode(" Include verified passages only", -1))
              ])
            ], 512), [
              [_vShow, _ctx.exportOptionsVisibleDevicesReport]
            ]),
            _createVNode(_component_q_separator),
            _createVNode(_component_q_table, {
              pagination: _ctx.devicesReportDataPagination,
              "onUpdate:pagination": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.devicesReportDataPagination) = $event)),
              "table-header-class": "bg-blue-brand text-white",
              rows: _ctx.devicesReportData,
              columns: _ctx.devicesReportColumns,
              "row-key": "passageTimeStamp",
              dense: "",
              "binary-state-sort": "",
              onRequest: _ctx.onDevicesReportRequest
            }, {
              "body-cell-passageTimeStamp": _withCtx((props) => [
                _createVNode(_component_q_td, { props: props }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.row.passageTimeStamp), 1)
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              "body-cell-pigRunName": _withCtx((props) => [
                _createVNode(_component_q_td, { props: props }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.row.pigRunName), 1)
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              "body-cell-markerName": _withCtx((props) => [
                _createVNode(_component_q_td, { props: props }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.row.markerName), 1)
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              "body-cell-toolName": _withCtx((props) => [
                _createVNode(_component_q_td, { props: props }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.row.toolName), 1)
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              "body-cell-coordinates": _withCtx((props) => [
                _createVNode(_component_q_td, { props: props }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.formatCoordinate(props.row.latitude, false) +
                _ctx.formatCoordinate(props.row.longitude, true) +
                _ctx.formatAltitude(props.row.altitude, true)), 1)
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              "body-cell-uid": _withCtx((props) => [
                _createVNode(_component_q_td, { props: props }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.row.uid), 1)
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              "body-cell-detection-count": _withCtx((props) => [
                _createVNode(_component_q_td, { props: props }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.row.detectionCount), 1)
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              "body-cell-passage-detected-frequency": _withCtx((props) => [
                _createVNode(_component_q_td, { props: props }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.row.detectionFrequency), 1)
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              "body-cell-graph-data": _withCtx((props) => [
                _createVNode(_component_q_td, { props: props }, {
                  default: _withCtx(() => [
                    (_ctx.isOnlySingleTypeOfPassage(props))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.passageWaveforms, (waveform) => {
                            return (_openBlock(), _createBlock(_component_q_btn, {
                              key: waveform.passageWaveformId,
                              size: "sm",
                              class: "q-mr-xs btn-brand",
                              dense: "",
                              icon: "show_chart",
                              label: _ctx.getWaveformLabel(waveform.passageWaveformType),
                              onClick: ($event: any) => (
                    _ctx.showChart(
                      props,
                      _ctx.getWaveformLabel(waveform.passageWaveformType)
                    )
                  )
                            }, null, 8, ["label", "onClick"]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_24, [
                          _createVNode(_component_q_btn_dropdown, {
                            size: "sm",
                            class: "q-mr-xs btn-brand",
                            dense: "",
                            icon: "show_chart"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_list, { dense: "" }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.passageWaveforms, (waveform) => {
                                    return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                      key: waveform.passageWaveformId,
                                      clickable: "",
                                      onClick: ($event: any) => (
                        _ctx.showChart(
                          { row: props.row },
                          _ctx.getWaveformLabel(waveform.passageWaveformType)
                        )
                      )
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_item_section, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_item_label, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.getWaveformLabel(waveform.passageWaveformType)), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])), [
                                      [_directive_close_popup]
                                    ])
                                  }), 128))
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              "body-cell-verify-passage": _withCtx((props) => [
                _createVNode(_component_q_td, { props: props }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_btn, {
                      size: "sm",
                      class: "btn-brand",
                      dense: "",
                      color: props.row.isVerified ? 'green' : 'red',
                      icon: props.row.isVerified ? 'check_circle_outline' : 'block',
                      onClick: ($event: any) => (_ctx.onVerifyPassageForDevicesReport(props.row))
                    }, null, 8, ["color", "icon", "onClick"])
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              "body-cell-machine-learning-data": _withCtx((props) => [
                _createVNode(_component_q_td, { props: props }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['elf', 'geo', 'mag', 'acc', 'tmr'], (type) => {
                      return (_openBlock(), _createElementBlock(_Fragment, null, [
                        (
                    props.row[`${type}MachineLearningResultList`] !==
                      undefined &&
                    props.row[`${type}MachineLearningResultList`].length !== 0
                  )
                          ? (_openBlock(), _createBlock(_component_MLBadge, {
                              key: type,
                              type: type,
                              results: props.row[`${type}MachineLearningResultList`]
                            }, null, 8, ["type", "results"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 64))
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              _: 1
            }, 8, ["pagination", "rows", "columns", "onRequest"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.showWaveformSelectionDialog,
      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.showWaveformSelectionDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"min-width":"300px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                _createElementVNode("div", { class: "text-h6" }, "Select Waveform to Verify", -1),
                _createElementVNode("div", { class: "text-body2 q-mt-sm" }, " Choose which waveform type to verify for this passage. ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_option_group, {
                  modelValue: _ctx.selectedWaveformIdForVerify,
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.selectedWaveformIdForVerify) = $event)),
                  options: _ctx.waveformOptionsForVerify,
                  type: "radio"
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, { align: "right" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_btn, {
                  flat: "",
                  label: "Cancel",
                  class: "btn-brand",
                  onClick: _ctx.onCancelWaveformSelection
                }, null, 8, ["onClick"]),
                _createVNode(_component_q_btn, {
                  flat: "",
                  label: "Confirm",
                  class: "btn-brand",
                  color: "primary",
                  disable: _ctx.selectedWaveformIdForVerify === null,
                  onClick: _ctx.onConfirmWaveformSelection
                }, null, 8, ["disable", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 512)), [
    [_vShow, _ctx.showReportManager]
  ])
}